import { defaultLanguage } from '../../../../config/prismic';

import { DocumentType } from '../../../shared/constants/Enums';

export const linkFormater = ({ type, lang, uid }) => {
  if (type === DocumentType.HOMEPAGE) {
    return `/${lang.slice(0, 2)}/blog/`;
  }

  if (
    type === DocumentType.PAGE ||
    type === DocumentType.CONTACT ||
    type === DocumentType.PRICING ||
    type === DocumentType.EVENTGALLERY ||
    type === DocumentType.QUOTEGENERATOR
  ) {
    return `/${lang.slice(0, 2)}/${uid}/`;
  }

  if (type === DocumentType.EVENT || type === DocumentType.EVENTTAG) {
    return `/${lang.slice(0, 2)}/templates/${uid}/`;
  }

  if (type === DocumentType.NOTFOUND) {
    return `/${lang.slice(0, 2)}/404/`;
  }

  if (type === DocumentType.HOMEPAGEWEB) {
    return lang === defaultLanguage ? `/` : `/${lang.slice(0, 2)}/`;
  }

  return `/${lang.slice(0, 2)}/blog/${uid}/`;
};
